export default __webpack_public_path__ + "static/media/maestro.e8bc8239.svg";